export class AddToolsModel {
    id: string;
    name: string;
    toolTypeId:number;
    competencyId: number;
    subCompetencyId: number;
    authorId:number;
    reviewerId:number;
    sharepointURL:string;
  }